import { Component, Injectable, EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { UserInfo, StandardApiError } from '@tecommon/structures/structures';
@Injectable()
export class CurrentUserInfoService {
    myMethod$: Observable<UserInfo>;
    private myMethodSubject = new Subject<UserInfo>();

    constructor() {
        this.myMethod$ = this.myMethodSubject.asObservable();
    }

    myMethod(data) {
        console.log(data); // I have data! Let's return it so subscribers can use it!
        // we can do stuff with data if we want
        this.myMethodSubject.next(data);
    }
}